import React from "react";

import getProductName from "@helpers/products/getProductName";

import type { Product } from "@typings/product/product";
import Icon from "@components/common/Icon";
import { removeFromCart } from "@store/cart";
import { useDispatch } from "react-redux";
import posthog from "posthog-js";

interface CartItemHeaderProps {
  cartItem: Product;
  redirectToProductPage: () => void;
}

const CartItemHeader = ({ cartItem, redirectToProductPage }: CartItemHeaderProps) => {
  const { item, configuration } = cartItem;
  const { quantity, price, oldPrice } = configuration;

  const dispatch = useDispatch();

  const handleRemoveFromCart = () => {
    dispatch(removeFromCart({ cartItems: [cartItem] }));

    if (typeof window !== "undefined") {
      posthog.capture("Remove from cart", {
        product_id: item.id,
        product_name: item.name,
      });
    }
  };

  return (
    <div className="cart-item__header">
      <div className="cart-item__title">
        <button className="cart-item__name" type="button" onClick={redirectToProductPage}>
          {cartItem.item.name}
        </button>
        <div className="cart-item__total">
          {item.category.name === "Free Gift" ? (
            <div className="cart-item__total-price__wrapper">
              <span className="cart-item__total-quantity">{quantity} x </span>
              <span className="cart-item__total-price">FREE</span>
            </div>
          ) : (
            <React.Fragment>
              <button onClick={handleRemoveFromCart} type="button" className="cart-item__remove">
                <Icon width={22} height={22} name="trash" />
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartItemHeader;
